import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="9"
    height="9"
    viewBox="0 0 9 9"
    fill="transparent"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M4.125 7.125L1.5 4.5L4.125 1.875M7.125 7.125L4.5 4.5L7.125 1.875" />
  </svg>
);
